import React from 'react';
import './PrintStyle.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import TitoLogo from '../assets/images/tito-logo.png';
import KKLogo from '../assets/images/kk-logo.png';

const ProductPrint = React.forwardRef((props, ref) => {
    const { data } = props;

    return (
        <div ref={ref} style={{ padding: 50 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <img src={KKLogo} alt="logo" style={{ height: 80, width: 80 }} />
                <h2 style={{ fontSize: '20px', margin: 0 }}>KK Foods</h2>
                <img src={TitoLogo} alt="logo" style={{ height: 80, width: 80 }} />
            </div>

            <div style={{ marginTop: 20, marginBottom: 15 }}>
                <Typography variant="h6" style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '16px' }}>
                    Products List
                </Typography>
            </div>

            <TableContainer>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontSize: '12px', fontWeight: 'bold' }}>Name</TableCell>
                            <TableCell sx={{ fontSize: '12px', fontWeight: 'bold' }}>Packing</TableCell>
                            <TableCell sx={{ fontSize: '12px', fontWeight: 'bold' }}>Category</TableCell>
                            <TableCell sx={{ fontSize: '12px', fontWeight: 'bold' }}>Machine</TableCell>
                            <TableCell sx={{ fontSize: '12px', fontWeight: 'bold' }}>Available Quantity</TableCell>
                            <TableCell sx={{ fontSize: '12px', fontWeight: 'bold' }}>Raw Material Quantity</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!!data &&
                            data?.map((row) => (
                                <TableRow
                                    key={row.id || row._id}
                                    sx={{
                                        '&:last-child td, &:last-child th': { border: 0 }
                                    }}
                                >
                                    <TableCell component="th" scope="row" sx={{ fontSize: '11px' }}>
                                        {row?.name}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '11px' }}>{row?.packing || '-'}</TableCell>
                                    <TableCell sx={{ fontSize: '11px' }}>{row?.category || '-'}</TableCell>
                                    <TableCell sx={{ fontSize: '11px' }}>{row?.machines || '-'}</TableCell>
                                    <TableCell sx={{ fontSize: '11px' }}>{row?.availableQuantity || '-'}</TableCell>
                                    <TableCell sx={{ fontSize: '11px' }}>{row?.rawMaterialQuantity || '-'}</TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
});

export default ProductPrint;
